// @ts-ignore
 
import request from "src/lib/axios";

/** 上传文件，小程序、app专用 POST /api/v1/app-file/upload */
export async function AppFileControllerUploadFileV1(
  body: MyApi.AppUploadFileDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseFileDto>("/api/v1/app-file/upload", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
